import { Route } from 'react-router-dom';
import { AppContext } from '../helpers/api-helpers';
import { isEmpty } from 'lodash';

function ProtectedRoute({
  component: Component,
  unauthenticated = undefined,
  unauthorized = undefined,
  authorizedGroups,
  requireAuth = true,
  ...rest
}) {
  const UnauthorizedComponent = unauthorized || (() => 'Unauthorized');
  const UnauthenticatedComponent = unauthenticated || UnauthorizedComponent;

  if (!Component) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <AppContext.Consumer>
          {({ authState, user }) => {
            if (requireAuth) {
              switch (authState) {
                default:
                case 'loading':
                  return null;
                case 'signIn':
                  return <UnauthenticatedComponent />;
                case 'signedIn': {
                  const isAuthorized =
                    isEmpty(authorizedGroups) ||
                    (user.groups &&
                      authorizedGroups.some((group) =>
                        user.groups.includes(group),
                      ));

                  if (!isAuthorized) {
                    return <UnauthorizedComponent />;
                  }

                  return (
                    <Component {...(props.match || {}).params} {...props} />
                  );
                }
              }
            } else {
              return <Component {...(props.match || {}).params} {...props} />;
            }
          }}
        </AppContext.Consumer>
      )}
    />
  );
}

export default ProtectedRoute;
